import { STATUSES } from "@/lib/constants";
import { Badge } from "ui/components/badge";

export function StatusDisplay({ value }) {

  return (
    <Badge className={STATUSES[value].className}>{STATUSES[value].label}</Badge>
  );
}
